
<template>
  <div v-wechat-title="title">
    <NativeBar ref="menu" v-model="NativeBarId" />
    <form action="/">
      <van-search v-model="serKey" readonly placeholder="请输入搜索关键词" @click="onSearch" />
    </form>
    <div id="bar" class="bar">
      <van-sidebar v-model="activeKey">
        <van-sidebar-item v-for="item in list" :key="item.id" :title="item.name" @click="onTypeClick(item)" />
      </van-sidebar>

    </div>
    <div id="bodys" class="bodys">
      <van-swipe v-if="typeAd" :autoplay="3000">
        <van-swipe-item v-for="(item, index) in typeAd" :key="index">
          <img :src="item.img" class="topImg" @click="jumpUrl(item.url)">
        </van-swipe-item>
      </van-swipe>
      <van-grid v-if="selectItem" :column-num="3" class="iconRect">
        <van-grid-item
          v-for="item in selectItem.childs"
          :key="item.id"
          @click="onIcon(item.id)"
        >
          <img :src="item.icon">
          {{ item.name }}
        </van-grid-item>
      </van-grid>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import NativeBar from '@/components/NativeBar'
import commondata from '@/commondata.js'
import { checkIsInAlipay, getUrlKey, jumpUrl } from '@/utils/base'
import { Button, Sidebar, SidebarItem, Search, Swipe, SwipeItem, Grid, GridItem } from 'vant'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  name: 'Storetype',
  components: {
    [Button.name]: Button,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [Search.name]: Search,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    NativeBar
  },
  data() {
    return {
      title: '产品分类',
      serKey: undefined,
      showSearch: false,
      activeKey: 0,
      offsetTopBar: 0,
      offsetTopBody: 0,
      NativeBarId: 'type',
      typeAd: [],
      list: [],
      selectItem: undefined,
      system: ''
    }
  },

  created() {
    this.system = getUrlKey('system')
    var key = getUrlKey('key')
    if (key) {
      this.serKey = key
    }
    this.onInit()
    this.loadBaseData()
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'type'
    }, 0)
  },
  activated() {
    this.NativeBarId = ''
    setTimeout(() => {
      this.NativeBarId = 'type'
    }, 0)
    this.$refs.menu.resetNum()
    var key = getUrlKey('key')
    if (key) {
      this.serKey = key
    }
    document.getElementById('bar').scrollTop = this.offsetTopBar
    document.getElementById('bodys').scrollTop = this.offsetTopBody
  },
  beforeRouteLeave(to, from, next) {
    this.offsetTopBar = document.getElementById('bar').scrollTop
    this.offsetTopBody = document.getElementById('bodys').scrollTop
    next()
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    jumpUrl,
    loadBaseData() {
      setTimeout(() => {
        if (!commondata.storeBase) {
          this.loadBaseData()
          return
        }
      }, 1000)
    },
    onSearch() {
      this.$router.push('/store/search')
    },
    onIcon(typeId) {
      this.$router.push('/store/list?type=' + typeId)
    },
    onInit() {
      request({
        url: '/data/getStoreType',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.list = response.data.list
        if (this.system === 'haiwang') { // 海王特殊处理
          this.list = this.list.filter(el => el.type === 'SCHEDULING')
        }
        // 支付宝特殊处理
        if (checkIsInAlipay()) {
          this.list = this.list.filter(el => el.type !== 'SCHEDULING')
        }
        this.selectItem = this.list[0]
        this.typeAd = commondata.storeBase.typeAd
      })
    },
    onTypeClick(item) {
      console.log('onTypeClick', item)
      this.selectItem = item
    }
  }
}
</script>
<style scoped>
.bar{
    overflow-y:scroll;
    /* height: 100vh; */
     position: absolute;
    left: 0px;
    right: 85px;
    top:54px;
    bottom: 50px;
}
.bar::-webkit-scrollbar {display:none}

.bodys{
    position: absolute;
    left: 85px;
    right: 0px;
    top:54px;
    bottom: 0px;
    background-color:#ffffff;
    overflow-y:scroll;
    margin-bottom: 50px;
    padding: 0 0.5em 0.5em 0.5em;
}
.bodys::-webkit-scrollbar {display:none}
.topImg{
    width: 100%;
}
.iconRect{
    font-size: 0.9em;
}
.iconRect img{
    width: 80%;
}
</style>
